<template>

<div>

  <LDBsTable
    url="company"
    defaultSort="name"
    defaultOrder="asc"
    :query="query"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-12">
      <label>{{ $t('name') }}</label>
      <input
        type="text"
        name="name"
        class="form-control"
        v-model="query.name"
        :placeholder="$t('type_name')"
      >
    </div>
  </LDBsTable>

</div>

</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'

export default {
  name: 'CompanyList',
  components: {
    LDBsTable
  },
  data () {
    return {
      columns: [
        {
          title: this.$t('name'),
          field: 'name',
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `<a href="#/main/company/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-pen"></i></a>`
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'empresas' }
      },
      query: {
        id: '',
        name: ''
      }
    }
  },
  methods: {
    clear() {
      this.query.name = ''
    }
  }
}

</script>
